export default {
  TEXT: 'Text',
  QUIZ: 'Quiz',
  FLASHCARD: 'FlashCard',
  MEMORY: 'Memory'
}
